import React, {PureComponent} from 'react';

import css from './TabVideo.module.css'

let timeout = null;

class TabVideos extends PureComponent {
	onEnded = () => {
		timeout = window.setTimeout(this.returnToDashboard, 1000);
	};

	returnToDashboard = () => {
		window.clearTimeout(timeout);
		this.video.currentTime = 0;
		this.props.videoFinished();
	};

	componentDidUpdate() {
		if (this.props.autoPlay && !!this.video) this.video.play();
	}

	render() {
		const {src, autoPlay/*, onPrevTab, onNextTab*/} = this.props;

		return (
			<div className={css.container}>
				<video
					ref={c => this.video = c}
					className={css.video}
					width="60%"
					controls={false}
					autoPlay={false}
					muted
					onEnded={this.onEnded}
				>
					<source src={src} type="video/mp4"/>
					Your browser does not support the video tag.
				</video>
			</div>
		);
	}
}

export default TabVideos;



// WEBPACK FOOTER //
// ./src/components/tabs/TabVideo.jsx